module.exports = __webpack_public_path__ + "static/media/redGuy.ecabe61b.jpeg";